import { render, staticRenderFns } from "./CS-quality-widget.vue?vue&type=template&id=8348ae50"
import script from "./CS-quality-widget.vue?vue&type=script&lang=js"
export * from "./CS-quality-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports